export enum LanguagesEnum {
  ENGLISH = "en_US",
  GERMAN = "de_DE",
}
